<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green my-row">
          <div class="card-icon">
            <md-icon>sports_esports</md-icon>
          </div>
          <h4 class="title">{{ sn }}</h4>
        </md-card-header>
        <h5 class="my-center-row">{{ address }}</h5>
        <div class="my-row">
          <md-button class="my-md-button md-success" @click.native="load()">
            <span class="material-icons">refresh</span>
            Обновить
          </md-button>
        </div>
        <div class="my-row">
          <md-button
            class="my-md-button md-success"
            @click.native="toControl()"
          >
            Управлять
          </md-button>
        </div>
        <div class="my-row">
          <md-button class="my-md-button md-success" @click.native="back()">
            К аппаратам
          </md-button>
        </div>
        <md-card-content v-if="isApvs">
          <div>{{ loadingMessage }}</div>
        </md-card-content>
        <md-card-content v-else>
          <mess-card
            v-for="item in model"
            :key="item.sn"
            :item="item"
          ></mess-card>
        </md-card-content>
        <div class="my-row">
          <md-button class="my-md-button md-success" @click.native="load()">
            <span class="material-icons">refresh</span>
            Обновить
          </md-button>
        </div>
        <div class="my-row">
          <md-button
            class="my-md-button md-success"
            @click.native="toControl()"
          >
            Управлять
          </md-button>
        </div>
        <div class="my-row">
          <md-button class="my-md-button md-success" @click.native="back()">
            к аппаратам
          </md-button>
        </div>
        <md-card-content></md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import MessCard from "../components/EngMessages/MessCard.vue";
// import { Pagination } from "@/components";

export default {
  // components: { MessCard, Pagination },
  components: { MessCard },
  computed: {
    isApvs() {
      if (this.model.length == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      sn: "",
      loadingMessage: "Загрузка данных",
      model: [],
      address: "",
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/EngApvsIndex", query: this.$route.query });
    },
    toControl() {
      this.$router.push({
        path: "/EngControl",
        query: this.$route.query,
      });
    },
    load() {
      const sn = this.$route.query.sn;
      this.address = this.$route.query.item.address;
      this.sn = sn;
      this.ajax.getEngMessages(
        this,
        { sn },
        (r) => {
          if (r.status == "ok") {
            this.model = r.data;
            if (r.data.length == 0) {
              this.loadingMessage = "Нет сообщений";
            }
          } else {
            this.showErrorNotify(r);
          }
        },
        (err) => {
          // console.log(err);
        }
      );
    },
  },
  mounted() {
    this.load();
  },
  watch: {},
};
</script>

<style lang="css" scoped>
.md-tabs {
  margin-bottom: 24px;
}

.material-icons {
  margin-right: 15px;
}

.my-md-button {
  width: 100%;
  height: 41px;
  margin-top: 5px;
  margin-bottom: 0px;
  margin-right: 20px;
}

.my-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-left: 20px;
}

.my-messages {
  color: red;
  font-weight: bold;
}

.my-message-item {
  margin-left: 10px;
}

.my-center-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>
